import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import firebase from 'firebase';
import mixins from '../mixins.js';
import Snotify, { SnotifyPosition } from 'vue-snotify/vue-snotify.min.js';
import 'vue-snotify/styles/material.css';
import axios from 'axios';

const options = {
  toast: {
    position: SnotifyPosition.rightTop,
  },
};

Vue.use(Vuex);
Vue.use(Snotify, options);
Vue.mixin(mixins);

export default new Vuex.Store({
  state: {
    user: null,
    users: null,
    isAuthenticated: false,
    token: null,
    loading: false,
    selectedUser: null,
    startingHour: 6,

    //appBaseColor: '#a12de7',
    colors: [
      'red',
      'pink',
      'purple',
      'deep-purple',
      'indigo',
      'blue',
      'light-blue',
      'cyan',
      'teal',
      'green',
      'light-green',
      'lime',
      'yellow',
      'amber',
      'orange',
      'deep-orange',
      'brown',
      'blue-grey',
      'grey',
    ],
    eventColors: [
      '#F44336',
      '#E91E63',
      '#9C27B0',
      '#673AB7',
      '#3F51B5',
      '#2196F3',
      '#1976d2',
      '#03A9F4',
      '#00BCD4',
      '#009688',
      '#4CAF50',
      '#8BC34A',
      '#CDDC39',
      '#FFEB3B',
      '#FFC107',
      '#FF9800',
      '#FF5722',
      '#795548',
      '#607D8B',
      '#9E9E9E',
      '#000000',
    ],
  },
  getters: {
    isAuthenticated(state) {
      return state.user !== null && state.user !== undefined;
    },
    eventColors: (state) => {
      return state.eventColors;
    },
    colors: (state) => {
      return state.colors;
    },
    // appBaseColor: (state) => {
    //   return state.appBaseColor;
    // },
    user(state) {
      return state.user;
    },
    isLoading(state) {
      return state.loading;
    },
    token(state) {
      return state.token;
    },
    SelectedUser(state) {
      return state.selectedUser;
    },
    startingHour(state) {
      return state.startingHour;
    },
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setUserList(state, payload) {
      state.users = payload;
    },
    setIsAuthenticated(state, payload) {
      state.isAuthenticated = payload;
    },
    setToken(state, payload) {
      state.token = payload;
    },
    setSelectedUser(state, payload) {
      state.selectedUser = payload;
    },
    setBaseColor(state, payload) {
      state.appBaseColor = payload;
    },

    load(state, payload) {
      state.loading = payload;
    },
  },
  actions: {
    setUser({ commit }, user) {
      commit('setUser', user);
    },

    async verifyRecapthca(payload) {
      await this._vm.$recaptchaLoaded();
      const token = await this._vm.$recaptcha(payload); // Execute reCAPTCHA with action "login".

      return axios.post('/api/verifyRecaptcha', { value: token });
    },
    setUserToken({ commit }, payload) {
      commit('setToken', payload);
    },

    signup({ commit }, { email, password }) {
      commit('load', true);
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(() => {
          commit('load', false);
          //commit('setUser', user);
          // commit('setIsAuthenticated', true);
        })
        .catch((error) => {
          commit('load', false);
          //commit('setUser', null);
          // commit('setIsAuthenticated', false);
          this._vm.showError(error.message);
        });
    },
    login({ commit }, { email, password }) {
      commit('load', true);

      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((user) => {
          commit('load', false);
          commit('setUser', user);

          commit('setIsAuthenticated', true);
          router.push('/');
        })

        .catch((error) => {
          commit('load', false);
          commit('setUser', null);

          commit('setIsAuthenticated', false);
          this._vm.showError(error.message);
          router.push('/login');
        });
    },

    logout({ commit }) {
      firebase
        .auth()
        .signOut()
        .then(() => {
          //router.push('/login');
          commit('setUser', null);
          commit('setToken', null);
          commit('setIsAuthenticated', false);
        })
        .catch((error) => {
          //router.push('/login');
          this._vm.showError(error.message);
          commit('setUser', null);
          commit('setToken', null);
          commit('setIsAuthenticated', false);
        });
    },

    tryAutoLogin({ commit }, payload) {
      commit('setUser', payload);
      commit('setIsAuthenticated', true);
    },
  },
  modules: {},
});
